<template>  
   <span v-html="iconSvg"></span>
</template>
<script>
import feather from "feather-icons";
export default {
  name: "Icon",
  props: {
    icon: {
      type: String,
      default: ""
    },
    size: Number,
    default: 24
  },
  computed: { 
    iconSvg: function () {
      var size = 24;
      if(this.size) size = this.size
      return feather.icons[this.icon].toSvg({ width: size,
      height: size} ) 
      
    }
  },
  mounted() {
    feather.replace();
  }
};
</script>